/**
 * List of options for the Barcode Reader types field
 *
 * @namespace tmrBarcodeReaderTypes
 * @type {ngConstant}
 */
export const constant = [
  'tmrBarcodeReaderTypes',
  {
    DatalogicBarcodeReaderDto: 'Datalogic Barcode Reader',
  },
]
